import styles from './styles.module.css';
import Image from "@/shared/components/Image/new"; //esto viene de destacada, importar img

const TituloMenu = (props) => {
    const {
    title,
    link,
    title1,
    link1,
    title2,
    link2,
    title3,
    link3,
    title4,
    link4,
    title5,
    link5,
    title6,
    link6,
    linkImage,
    limit
} = props;
    let cabezal = "";
    if (linkImage != "") cabezal = <Image src={linkImage} />;
    if (title != "" && link != "") cabezal = <h2><a href={link}>{title}</a></h2>;
    if (title != "" && link == "") cabezal = <h2>{title}</h2>;

    return (
        <div>
            <div className={`${styles['title-content']}`}>
                {(title || linkImage) && <div className={`${styles["contenedor-gral-tittulo-container"]}`}>
                    <div className={`${styles["contenedor-left-titulo"]}`}> {cabezal}</div>

                    <div className={`${styles["scroll-margin"]}`}>
                        <nav className={`${styles["menu-el-scroll"]}`}>
                            <ul>
                                {link1 && title1 && <li><a href={link1} >{title1}</a></li>}
                                {link2 && title2 && <li><a href={link2} >{title2}</a></li>}
                                {link3 && title3 && <li><a href={link3} >{title3}</a></li>}
                                {link4 && title4 && <li><a href={link4} >{title4}</a></li>}
                                {link5 && title5 && <li><a href={link5} >{title5}</a></li>}
                                {link6 && title6 && <li><a href={link6} >{title6}</a></li>}
                            </ul>
                        </nav>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default TituloMenu;
